import React from 'react';
import { CardEnum } from '@colonist/game-states';
import { CardDataController } from '@colonist/game-card-types';
import { T } from '@colonist/ui';
import { CARD_TIP_BODY, CARD_TIP_TITLE } from '@colonist/ui-game';
import { UIGameProgressCardTooltipBody } from '../../common/UIGameProgressCardTooltipBody/UIGameProgressCardTooltipBody.tsx';
import { getBankCardStackCountRange } from './getBankCardStackSize.ts';
function getExtraTooltipBody(modeSetting, cardType, cardCount) {
    if (cardCount === 0) return {
        key: 'strings:game.tooltips.cardCountInStack.empty'
    };
    const { lowerBound, upperBound } = getBankCardStackCountRange(modeSetting, cardType, cardCount);
    return {
        key: 'strings:game.tooltips.cardCountInStack.full',
        options: {
            lowerBound: lowerBound,
            upperBound: upperBound
        }
    };
}
export function getBankCardTooltip(cardEnum, cardCount, hideBankCards, modeSetting, progressCards, translationKeyContext) {
    const cardData = CardDataController.getCardDataForCard(cardEnum);
    const tipTitle = {
        ...CARD_TIP_TITLE[cardEnum],
        options: {
            context: translationKeyContext
        }
    };
    const tipBody = {
        ...CARD_TIP_BODY[cardEnum],
        options: {
            context: translationKeyContext
        }
    };
    const title = cardData ? /*#__PURE__*/ React.createElement(T, {
        id: tipTitle
    }) : undefined;
    const isProgressCard = cardEnum === CardEnum.ProgressCardBack;
    if (isProgressCard && progressCards) {
        return {
            title: title,
            content: /*#__PURE__*/ React.createElement(UIGameProgressCardTooltipBody, {
                hideBadge: hideBankCards,
                progressCards: progressCards,
                modeSetting: modeSetting
            }),
            centerText: true
        };
    }
    const extraTooltipBody = hideBankCards && cardData ? getExtraTooltipBody(modeSetting, cardData.cardTypeEnum, cardCount) : undefined;
    const content = /*#__PURE__*/ React.createElement(React.Fragment, null, cardData && /*#__PURE__*/ React.createElement(T, {
        id: tipBody
    }), extraTooltipBody !== undefined && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement(T, {
        id: extraTooltipBody
    })));
    return {
        title: title,
        content: content
    };
}
